<label class="radio">
  <span class="radio__container">
      <input type="radio" [formControl]="fc" [value]="value">
  </span>
  <div class="radio__label-wrapper" *ngIf="label || labelDescription">
    <div class="radio__label" *ngIf="label">{{ label }}</div>
    <div class="text-small text-color-light" *ngIf="labelDescription">{{ labelDescription }}</div>
  </div>
</label>
